// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"271":"bonos-regalo","669":"ok","757":"ko","779":"error"}[chunkId] || chunkId) + "." + {"271":"cfcab062","578":"c7728321","669":"08247fa7","757":"624f939e","779":"d24abef7","874":"87b89dbf"}[chunkId] + ".js";
};